@if (!loading) {
<div class="box">
  <button mat-button class="back-btn" (click)="back()">
    <mat-icon>arrow_back</mat-icon> Back
  </button>

  <div class="page-header">
    <div>
      <p class="page-title">Groups</p>
      <p class="page-desc">Groups let you organize users under <strong>{{ applicationName }}</strong>. Subscribe a group to a channel and all its members will receive notifications.</p>
    </div>
    <button mat-flat-button class="add-btn" (click)="openModal(group, 'New', applicationName, false)">
      <mat-icon>add</mat-icon>
      New Group
    </button>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon stat-icon--total">
        <mat-icon>group</mat-icon>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ groupCount }}</span>
        <span class="stat-label">Groups</span>
      </div>
    </div>
  </div>

  <div class="table-toolbar">
    <mat-form-field class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search groups…" />
    </mat-form-field>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="row-icon"><mat-icon>group</mat-icon></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="group_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Group Name</th>
        <td mat-cell *matCellDef="let element">{{ element.group_name }}</td>
      </ng-container>

      <ng-container matColumnDef="Description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let element">{{ element.Description }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button class="action-btn" title="Edit"
                  (click)="openModal(element, 'Edit', applicationName, true); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matNoDataRow>
        <td colspan="4">
          <div class="empty-state">
            <mat-icon>group_off</mat-icon>
            <p>No groups found</p>
          </div>
        </td>
      </tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          class="table-row" (click)="openModal(row, 'Edit', applicationName, true)"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons aria-label="Select page">
  </mat-paginator>
</div>
}
@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
